<template>
  <div class="container">
    <TopHeader title="卡管理" returnPath="Home"></TopHeader>
    <div v-if="cardDetail" class="main-container">
      <div class="card-info">
        <div class="card-info-title">
          <span>持卡人</span>
          <span>{{ name }}</span>
        </div>
        <CommonBorder></CommonBorder>
        <div class="card-info-item">
          <span>状态</span>
          <span :class="cardDetail.status === 1 ? 'normal' : 'loss'">
            {{ cardDetail.status === 1 ? '正常' : '挂失' }}
          </span>
        </div>
        <div class="card-info-item">
          <span>卡号</span>
          <span class="right">
            {{ cardDetail.cardSn }}
          </span>
        </div>
        <div class="card-info-item">
          <span>卡费</span>
          <span class="right">
            <span style="margin-right: 2px">¥</span>
            {{ cardDetail.cardMoney / 100 }}
          </span>
        </div>
        <div class="card-info-item">
          <span>押金</span>
          <span class="right">
            <span style="margin-right: 2px">¥</span>
            {{ cardDetail.deposit / 100 }}
          </span>
        </div>
        <div class="btn-content">
          <van-button
            v-if="cardDetail.status === 1"
            size="mini"
            class="btn-a"
            plain
            @click="handleChangeCard"
          >
            变更
          </van-button>
          <van-button
            size="mini"
            plain
            :class="cardDetail.status === 1 ? 'btn-a' : 'btn-a btn-b'"
            @click="handleCard"
          >
            {{ cardDetail.status === 1 ? '挂失' : '解挂' }}
          </van-button>
        </div>
      </div>
    </div>
    <div v-else class="empty-container">
      <div class="main-content">
        <div class="main-title">卡号</div>
        <div class="main-text">
          <van-field
            placeholder="请输入卡号"
            input-align="right"
            v-model="form.newCardSn"
            maxlength="10"
          />
        </div>
      </div>
      <CommonBorder></CommonBorder>
      <div class="btn-content">
        <van-button size="mini" plain class="btn" @click="handldBinding">
          绑定
        </van-button>
      </div>
    </div>

    <!-- 提示弹窗 -->
    <van-dialog
      class="dialog"
      v-model="isShowLossDialog"
      showCancelButton
      cancelButtonColor="#999999"
      confirmButtonColor="#FFA900"
      confirmButtonText="确定"
      @cancel="isShowLossDialog = false"
      @confirm="lossCard"
    >
      <template>
        <div class="head">
          <div class="title">温馨提示</div>
          <div class="content">确定挂失该卡吗?</div>
        </div>
      </template>
    </van-dialog>
  </div>
</template>

<script>
import TopHeader from '@/components/topHeader/index.vue';
import CommonBorder from '@/components/commonBorder/index.vue';
import defaultImg from '@/components/defaultImg/index.vue';
import { getCard, cardLoss, addOrChangeCard } from '@/api/card';
import { validCardNumber } from '@/utils/verify';
export default {
  name: 'CardManage',
  components: {
    TopHeader,
    CommonBorder,
    defaultImg
  },
  data() {
    return {
      isShowLossDialog: false,
      loading: false,
      cardDetail: null,
      name: JSON.parse(sessionStorage.getItem('personInfo')).name,
      role: null,
      form: {}
    };
  },
  async created() {
    await this.getCardDetail();
  },
  mounted() {},
  methods: {
    async getCardDetail() {
      try {
        this.loading = true;
        const res = await getCard();
        if (res.data.length > 0) {
          this.cardDetail = res.data[0];
        }
        console.log(res);
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    async handleCard() {
      if (this.cardDetail.status === 1) {
        this.role = this.cardDetail.role;
        this.isShowLossDialog = true;
      } else {
        this.$toast('解挂请联系管理员');
      }
    },
    async lossCard() {
      try {
        this.loading = true;
        const res = await cardLoss(this.cardDetail.id, this.role);
        if (res.code === 0) {
          this.$toast('挂失成功');
          await this.getCardDetail();
        }
      } catch (e) {
        console.log(e);
      } finally {
        await this.getCardDetail();
      }
    },

    handleChangeCard() {
      this.$router.push({
        name: 'BindingCard',
        query: {
          form: JSON.stringify(this.cardDetail)
        }
      });
    },

    async handldBinding() {
      if (!this.form.newCardSn) {
        this.$toast('请输入卡号');
        return;
      }
      if (!validCardNumber(this.form.newCardSn)) {
        this.$toast('请输入正确的10位纯数字卡号');
        return;
      }
      const data = {
        newCardSn: this.form.newCardSn,
        oldCardSn: this.form.oldCardSn || '',
        cardId: this.form.cardId || ''
      };
      const res = await addOrChangeCard(data);
      if (res.code === 0) {
        this.$toast('绑定成功');
        this.getCardDetail();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .main-container {
    flex: 1;
    width: 100%;
    overflow: auto;
    box-sizing: border-box;
    padding: 0 16px;
    .card-info {
      margin-top: 10px;
      background-color: #fff;
      box-sizing: border-box;
      border-radius: 10px;
      .card-info-title {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 50px;
        justify-content: space-between;
        font-size: 16px;
        color: #333;
        font-weight: 500;
        box-sizing: border-box;
        padding: 0 16px;
      }
      .card-info-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 45px;
        justify-content: space-between;
        font-size: 16px;
        color: #333;
        font-weight: 400;
        box-sizing: border-box;
        padding: 0 16px;
        .right {
          color: #666;
        }
        .normal,
        .loss {
          width: 42px;
          height: 21px;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ffffff;
          font-size: 13px;
          font-weight: 500;
        }
        .normal {
          background-color: #00b893;
        }

        .loss {
          background-color: #ed3944;
        }
      }
      .btn-content {
        display: flex;
        justify-content: end;
        flex-direction: row;
        height: 60px;
        box-sizing: border-box;
        padding: 0 16px;
        align-items: center;
        .btn-a {
          width: 77px;
          height: 33px;
          background: #fa5050;
          font-size: 16px;
          color: #fff;
          border-radius: 4px;
          border-color: #fa5050;
          margin-left: 10px;
        }
        .btn-b {
          background: #e5e5e5;
          border-color: #e5e5e5;
        }
      }
    }
  }
  .empty-container {
    margin-top: 10px;
    box-sizing: border-box;
    border-radius: 10px;
    flex: 1;
    width: 100%;
    overflow: auto;
    .main-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 45px;
      color: #333;
      box-sizing: border-box;
      padding: 0 16px;
      background: #fff;
      .main-title {
        font-size: 16px;
        flex: 1;
      }
      .main-text {
        width: 100px;
        text-align: right;
      }
    }
    .btn-content {
      display: flex;
      justify-content: end;
      flex-direction: row;
      height: 60px;
      box-sizing: border-box;
      padding: 0 16px;
      align-items: center;
      margin-top: 30px;
      .btn {
        width: 100%;
        height: 44px;
        background: #fa5050;
        font-size: 18px;
        color: #fff;
        border-radius: 4px;
        border-color: #fa5050;
      }
    }
  }
}
.dialog {
  width: 343px;
  height: 161px;
  border-radius: 10px;
  .head {
    box-sizing: border-box;
    height: 110px;
    padding-top: 28px;
    text-align: center;

    .title {
      color: #333333;
      font-size: 18px;
      font-family: 'PingFangSC-Regular';
      font-weight: 500;
      line-height: 18px;
    }
    .content {
      font-size: 16px;
      font-family: 'PingFangSC-Regular';
      font-weight: 400;
      color: #666666;
      margin: 24px 0;
      line-height: 16px;
    }
  }
  ::v-deep .van-button__text {
    font-size: 18px;
    font-family: 'PingFangSC-Regular';
    font-weight: 500;
    line-height: 18px;
  }
}

::v-deep .van-cell {
  height: 40px;
  line-height: 40px;
  padding: 2px;
}
</style>
